import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { MEMBER_SEARCH_SCREEN } from '../constants/category';
import filter from 'lodash.filter';

export default function memberViewProfilesReducer(state = initialState.memberViewProfiles, action) {
  switch (action.type) {
    case types.MS_UPDATE_MEMBER_VIEW_PROFILES: {
      return state.merge({ ...action.data });
    }
    case types.POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS: {
      const { LIKE, IGNORE, UNLIKE, FAVORITE } = MEMBER_SEARCH_SCREEN.ACTION_TYPE;
      let { histories } = Immutable.asMutable(state);
      let updateObject = {};
      switch (action.actionType) {
        case IGNORE: {
          if (histories && histories.length > 0 && action.isRealoadData) {
            histories = filter(histories, (item, index) => index !== action.index);
          } else {
            histories = filter(histories, (item, index) => index !== (histories.length > 2 ? 1 : 0));
          }
          return state.merge({ histories });
        }
        case LIKE:
        case UNLIKE:
          if (action.actionSuccess) {
            updateObject = (action.params.Type === LIKE && {
              isLiked: action.actionType === LIKE,
              isLikedMutual: action.isLikedMutualMatch,
            }) || {
              isFavorited: action.params.Type === FAVORITE && action.actionType === LIKE,
              isFavoritedMutual: action.isFavouritedMutualMatch,
              // isLiked: action.actionType === LIKE,
              // isLikedMutual: action.isFavouritedMutualMatch
            };
            if (
              action.actionType === UNLIKE &&
              action.index &&
              state.histories[action.index] &&
              state.histories[action.index].profileIntersection?.isFavorited
            ) {
              updateObject = {
                ...updateObject,
                isFavorited: false,
                isFavoritedMutual: false,
              };
            }
          }
          break;
        default:
          break;
      }

      if (action.index || action.index === 0) {
        if (histories !== null && histories.length > 0 && action.isRealoadData) {
          state = state.setIn(['histories', action.index], {
            ...action.user,
            profileIntersection: {
              ...action.user.profileIntersection,
              ...updateObject,
            },
          });
        } else {
          state = state.setIn(['histories', histories.length > 2 ? 1 : 0], {
            ...action.user,
            profileIntersection: {
              ...action.user.profileIntersection,
              ...updateObject,
            },
          });
        }
      }
      return state;
    }
    // eslint-disable-next-line no-case-declarations
    case types.LOAD_MORE_USERS_MEMBER_SEARCH_SUCCESS: {
      let { histories } = Immutable.asMutable(state);
      if (histories && histories.length > 0) {
        const newUser = action.data && action.data.users ? action.data.users : action.data;
        histories = [...histories, ...newUser];
      }
      return state.merge({
        histories,
      });
    }
    default:
      return state;
  }
}
